import React, { FunctionComponent, useEffect, useState, useLayoutEffect } from 'react';
import { initCardObserverAnimation } from './util';
import { article } from '@Api';
import { IBarkeCardData } from '../context';
import { colorArr } from './const';
import cx from 'classnames';
import styles from './brakeCard.module.less';
import './common.less'

interface IProps {
  dataSource: IBarkeCardData[]
}

const { fetchHotsell } = article;
const firstHeaderWidth = '104px'

const BrakeCard: FunctionComponent<IProps> = ({ dataSource }) => {

  useLayoutEffect(() => {
    const eles = document.querySelectorAll('.brake-card');

    if (eles.length) {
      initCardObserverAnimation(eles);
    }

  }, [dataSource])

  return (
    <div className={styles["brake-card"]}>
      {
        dataSource.map((item, inx) => (
          <div className={cx(styles['card-item'], 'brake-card')}  key={inx}>
            <div className={cx(styles['card-wrapper'], "card-wrapper")}>
              <div className={styles['card-title']}>
                <i style={{ backgroundColor: colorArr[inx] }}></i>
                <h4>{item.title}</h4>
              </div>
              <div className={styles['card-info']}>
                <img src={item.thumb} alt="" />
                <div className={styles['card-detail']}>
                  <h5>實測環境:<span>{item.environment}</span></h5>
                  <p style={{ color: colorArr[inx] }}>{item.value}{item.unit}</p>
                </div>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default BrakeCard;